module.exports = __webpack_public_path__ + "static/kid4-c24200579a8f5a1e5148d1ee67ea9b3f.jpg";